import request from './serve'
import requestTwo from './serveTwo'

// 获取到机器人的配置
export const getRobotConfig = (data) => {
  console.log(data)
  return request({
    url: '/api/config',
    method: 'post',
    data
  })
}

// 获取默认配置的接口
export const initApp = (data) => {
  return request({
    url: '/api/robot/index',
    method: 'post',
    data
  })
}
export const wxConfig = (data) => {
  return request({
    url: '/api/wx/config?url=' + data,
    method: 'get'
  })
}

// 问答接口
export const askQuestion = (data) => {
  return request({
    url: '/api/robot/index',
    method: 'post',
    data
  })
}

// 输入联想
export const verbInput = (data) => {
  return request({
    url: '/api/knowledgeBase/searchQuestionByNlp',
    method: 'post',
    data
  })
}

// 获取热点问题
export const getHotList = (data) => {
  return request({
    url: '/api/knowledgeBase/hotQuestions',
    method: 'post',
    data
  })
}

// 反馈知识的是否有帮助
export const feedback = (data) => {
  return request({
    url: '/api/robot/useful',
    method: 'post',
    data
  })
}

// 退出当前的场景
export const exitScene = data => {
  return request({
    url: '/api/robot/toScene',
    method: 'post',
    data
  })
}

// 记录栏目导航
export const setNavigation = (data) => {
  return request({
    url: '/api/robot/setNavigation',
    method: 'post',
    data
  })
}

// deepseek 接口 2025年02月21日
export const deepseekChat = (data) => {
  return requestTwo({
    url: '/api/thirdparty-stream/chat_message/019a0f02-45cb-7470-a4dd-5a67b3d1403b',
    method: 'post',
    key: 'deep',
    data: data,
    responseType: 'stream'
  })
}
